export enum PredeterminedReportType {
  Appointments,
  CashClosing,
  Commissions,
  Services,
  Customers,
}